import Constant from "./constants";
import { useDomainConfig } from "../hooks/useDomainConfig";

const defineStatusIcon = (providerObject, status) => {
  // Add error handling for undefined providerObject
  if (!providerObject) {
    // console.warn('[ProviderIcons] Provider object is undefined, using default icon');
    return 'https://avvmedia.blob.core.windows.net/avv-media/networkFilters/generic.png'; // Default fallback icon
  }

  // Add error handling for missing icon property
  if (!providerObject.icon) {
    // console.warn('[ProviderIcons] Provider object missing icon property:', providerObject);
    return 'https://avvmedia.blob.core.windows.net/avv-media/networkFilters/generic.png'; // Default fallback icon
  }

  let iconSrc = providerObject.icon;
  console.log("device status:", status);
  switch (status) {
    case "A":
      if (providerObject.greenIcon) iconSrc = providerObject.greenIcon;
      else iconSrc = 'https://avvmedia.blob.core.windows.net/avv-media/networkFilters/generic.png';
      break;
    case "NA":
      if (providerObject.redIcon) iconSrc = providerObject.redIcon;
      else iconSrc = 'https://avvmedia.blob.core.windows.net/avv-media/networkFilters/generic.png';
      break;
    default:
      if (providerObject.greyIcon) iconSrc = providerObject.greyIcon;
      else iconSrc = 'https://avvmedia.blob.core.windows.net/avv-media/networkFilters/generic.png';
      break;
  }

  return iconSrc;
};
export const GetIconSrc = ({ location, networkFilters, deviceAvailable }) => {
  const domainConfig = useDomainConfig();
  
  // Add error handling for missing parameters
  if (!location) {
    // console.warn('[ProviderIcons] Location is undefined');
    return '/logo/amikCharge.jpg';
  }
  
  if (!networkFilters || !Array.isArray(networkFilters)) {
    // console.warn('[ProviderIcons] NetworkFilters is undefined or not an array:', networkFilters);
    return '/logo/amikCharge.jpg';
  }
  
  //if provider is chargemiles we will whitelabel it with domain provider
  const provider =
    location?.provider === Constant.domainProviderList["chargemiles"]
      ? domainConfig.provider
      : location?.provider;

  // console.log(`[ProviderIcons] Looking for provider: ${provider} in ${networkFilters.length} network filters`);
  
  const networkProvider = networkFilters.find(
    (network) => network.name === provider
  );

  const genericNetworkProvider = networkFilters.find(
    (network) => network.name === "GENERIC"
  );

  // console.log(`[ProviderIcons] Found networkProvider:`, networkProvider);
  // console.log(`[ProviderIcons] Found genericNetworkProvider:`, genericNetworkProvider);

  if (networkProvider?._id) {
    // console.log(`[ProviderIcons] Using networkProvider for ${provider}`);
    return defineStatusIcon(networkProvider, deviceAvailable);
  } else {
    // console.log(`[ProviderIcons] Using genericNetworkProvider for ${provider}`);
    return defineStatusIcon(genericNetworkProvider, deviceAvailable);
  }
};
